import React from "react";
import "./programs.css";
import {useSelector} from "react-redux";
import InstitutionUserPrograms from "./components/InstitutionUserPrograms";
import {PageErrorMessage} from "../../components/PageErrorMessage";

const MasterClasses = () => {
    const userType = useSelector((state) => state?.auth?.userData?.user_type);

    if (userType === 4) {

        const error = {
            'statusCode': 403,
            'message': 'Page is not available for your role'
        };

        return <PageErrorMessage
            error={error}
            entityTitle="Programs"
        />;
    }

    return <InstitutionUserPrograms />;
};

export default MasterClasses;